/**
 * The status options of a stock edit select: `Převedeno` is not a state anyone may choose (only a
 * transfer between group firmas sets it), but a transferred row must still SHOW it — an unknown value
 * makes a controlled <select> silently fall back to its first option.
 */
export function statusOptions(statuses: readonly string[], current: string | null | undefined): string[] {
  return current === 'Převedeno' && !statuses.includes('Převedeno') ? [...statuses, 'Převedeno'] : [...statuses];
}
